import { jsx as _jsx } from "react/jsx-runtime";
import PasswordStrengthBar from "react-password-strength-bar";
var InputPasswordStrengthBar = function (_a) {
    var password = _a.password, minLength = _a.minLength, shortScoreWord = _a.shortScoreWord, scoreWords = _a.scoreWords;
    return (_jsx(PasswordStrengthBar, { password: password, 
        // Note: scoreWordClassName gets overridden by default scoreWordStyle, thus is must manually be set
        scoreWordStyle: {
            margin: "0.5rem 0 0 0",
            fontSize: "0.875rem",
            color: "rgb(107 114 128)",
            textAlign: "left"
        }, shortScoreWord: shortScoreWord, scoreWords: [
            scoreWords.bad,
            scoreWords.weak,
            scoreWords.ok,
            scoreWords.good,
            scoreWords.strong,
        ], minLength: minLength }));
};
export default InputPasswordStrengthBar;
